import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryEditLessonInPublicLibraryConfirm = props => (
	<Confirm
		btOne={localize('edit_lesson_in_publiclibrary_cancel')}
		btTwo={localize('edit_lesson_in_publiclibrary_confirm')}
		alertTitle={localize('edit_lesson_in_publiclibrary_title')}
		alertMessage={localize('edit_lesson_in_publiclibrary_description')}
		actionButtonType={0}
		actionOne={props.actions.closeEditLessonInPublicLibraryConfirm}
		actionTwo={() => {
			props.actions.editLessonInPublicLibrary(props.lessonData)
		}}
		closeAction={props.actions.closeEditLessonInPublicLibraryConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeEditLessonInPublicLibraryConfirm: myLibraryActions.closeEditLessonInPublicLibraryConfirm,
		editLessonInPublicLibrary: myLibraryActions.editLessonInPublicLibrary,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryEditLessonInPublicLibraryConfirm)
